import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2e10d580"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mix-selector-content cm-ui-mr15" }
const _hoisted_2 = {
  key: 0,
  class: "btn-group task-time-edit__btn-group gap-x-10",
  style: {"line-height":"normal"}
}
const _hoisted_3 = {
  key: 0,
  class: "task-time-edit__after"
}
const _hoisted_4 = { class: "task-time-edit__after-left" }
const _hoisted_5 = { class: "task-time-edit__after-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskTimeSelect = _resolveComponent("TaskTimeSelect")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compData, (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "mix-selector-container",
        key: item
      }, [
        _renderSlot(_ctx.$slots, "before", {
          row: item,
          index: idx
        }, undefined, true),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_TaskTimeSelect, {
            "is-range": _ctx.isRange,
            idx: idx,
            "main-switch": _ctx.mainSwitch,
            "mix-type": item[_ctx.frequencyKey] ?? _ctx.mixType,
            modelValue: _ctx.compData[idx],
            "onUpdate:modelValue": ($event: any) => ((_ctx.compData[idx]) = $event)
          }, null, 8, ["is-range", "idx", "main-switch", "mix-type", "modelValue", "onUpdate:modelValue"])
        ]),
        (_ctx.maxTasks !== 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (idx === 0)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    style: {"padding":"8px","border-radius":"99999px !important","border-width":"2px","box-sizing":"border-box","width":"32px","height":"32px"},
                    circle: "",
                    plain: "",
                    size: "mini",
                    onClick: _ctx.addSelector,
                    icon: "el-icon-plus"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"padding":"8px","border-radius":"99999px !important","border-width":"2px","box-sizing":"border-box","width":"32px","height":"32px"},
                circle: "",
                plain: "",
                size: "mini",
                onClick: ($event: any) => (_ctx.subSelector(idx)),
                icon: "el-icon-minus"
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.hasAfterRow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "after-tip", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "after-extra", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}